import { useQuery } from "@tanstack/react-query";
import { spbTransferAPI } from "../spbTransferAPI.ts";

export const useGetSbpTransferScheduleQuery = ({ amount, fasCode }: { amount: string; fasCode: string }) => {
  return useQuery ({
    queryKey: ["sbp-transfer-schedule", amount, fasCode],
    queryFn: ({ signal }) => spbTransferAPI.getSchedule({ amount, fasCode, signal }),
    enabled: !!amount && !!fasCode,
    staleTime: 5 * 60 * 1000, // 5мин
    gcTime: 15 * 60 * 1000, // 15мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
